export const makeAppHeaderDetails = app => {
  var _app$vendor$partnerTi;
  return {
    name: app.name,
    key: app.key,
    icon: app.icon,
    ratings: app.ratings,
    origin: app.origin,
    partner: {
      name: app.vendor.name,
      link: app.vendor.link,
      partnerTierType: (_app$vendor$partnerTi = app.vendor.partnerTier) === null || _app$vendor$partnerTi === void 0 ? void 0 : _app$vendor$partnerTi.type
    },
    distribution: app.distribution
  };
};